<template>
  <div id="app">

    <keep-alive :include="keepalive_components">
      <router-view class="router-view"/>
    </keep-alive>
  </div>
</template>
<script>
import Vue from 'vue'
import wjtHttp from './js/http'
export default {
  name: 'App',
  data() {
    return{
      keepalive_components:[]
    }
  },
  beforeCreate(){
    Vue.prototype.wjtHttp = wjtHttp
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
table {
    border-collapse: separate;
    border-spacing: 0;
    border-top: 1px solid #e6e6e6;
    border-left: 1px solid #e6e6e6;
    border-right:1px solid #e6e6e6;
    border-top:1px solid #e6e6e6;
}
td {
    border: 1px solid #e6e6e6;
    border-top: none;
    border-left: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue